import { render, staticRenderFns } from "./NotificationsScreen.vue?vue&type=template&id=bd9ec916&scoped=true&"
import script from "./NotificationsScreen.vue?vue&type=script&lang=ts&"
export * from "./NotificationsScreen.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsScreen.vue?vue&type=style&index=0&id=bd9ec916&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd9ec916",
  null
  
)

export default component.exports